<template>
  <div class="login margin-bottom-l margin-top-l">
    <div class="login__bg"></div>
    <div class="login__content">
      <div class="login__brand">
        <div class="logo-square-wrapper">
          <login-logo-mobile class="logo-square" />
        </div>
      </div>

      <div class="login__form align-center">
        <login-logo-desktop class="logo-horizontal" />
        <h4 v-show="displaySuccess" >{{ $t('health.updateLicense.accountSuccessfullyActivated') }}</h4>
        <h4 v-show="displayError" >{{ $t('health.updateLicense.errorActivatingAccount') }}</h4>
        <div v-if="displayError">
          <p
            v-show="displayErrorRetry"
            class="note"
            v-html="$t('health.updateLicense.errorActivatingAccountDetailsRetry')">
          </p>
          <p
            v-show="displayErrorAlreadyHaveEntitlement"
            class="note"
            v-html="$t('health.updateLicense.errorActivatingAccountAlreadyHaveEntitlement')">
          </p>
          <p
            v-show="displayErrorInvalidLicense"
            class="note"
            v-html="$t('health.updateLicense.errorActivatingAccountInvalidLicense')">
          </p>
          <p
            v-show="!displayErrorRetry && !displayErrorAlreadyHaveEntitlement && !displayErrorInvalidLicense"
            class="note"
            v-html="$t('health.updateLicense.errorActivatingAccountDetails')">
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Dwall from '@/components/shared/logos/Dwall';
import PoweredBy from '@/components/shared/logos/PoweredBy';
import LabelInput from '@/components/shared/forms/LabelInput';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import LoginLogoMobile from '@/components/shared/logos/LoginLogoMobile';
import LoginLogoDesktop from '@/components/shared/logos/LoginLogoDesktop';
import licenseApi from 'BRAND/api/updateLicense';

export default {
  name: 'AssignLicense',
  components: {
    LabelInput,
    FontAwesomeIcon,
    Dwall,
    LoginLogoDesktop,
    PoweredBy,
    LoginLogoMobile
  },
  data () {
    return {
      code: null,
      displayError: false,
      displayErrorRetry: false,
      displayErrorAlreadyHaveEntitlement: false,
      displayErrorInvalidLicense: false,
      displaySuccess: false
    };
  },
  mounted () {
    this.code = this.$route.query.code;
    if (this.code != null) {
      this.sendLicenseData(this.code);
    }
  },
  methods: {
    sendLicenseData (license) {
      licenseApi.updateLicense(this, license).then(() => {
        this.displaySuccess = true;
      }, (error) => {
        if (error.status === 500) {
          this.displayErrorRetry = true;
        } else if (error.status === 409) {
          this.displayErrorAlreadyHaveEntitlement = true;
        } else if (error.status === 400 && error.body.message === 'Invalid license') {
          this.displayErrorInvalidLicense = true;
        }
        this.displayError = true;
      });
    }
  }
};

</script>

<style lang="scss" scoped>
span:hover {
  color: #F35647;
  cursor: pointer;
}
@import "src/stylesheets/variables";
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  &:after {
    content: "";
    background-size: auto 100%;
    position: absolute;
    top: 13%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 1;
    @media (min-width: $screen-l) {
      background: no-repeat left center url(~BRAND/assets/login-bg.jpg);
      z-index: -3;
      background-position: left top;
      background-size: auto;
    }
  }
  &__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    background-color: $login-background;
    @media (min-width: $screen-l) {
      background-color: transparent;
      background-image: radial-gradient(
          circle at 23% 35%,
          rgba($login-background, 0.5),
          rgba($login-background, 0.6),
          rgba($login-background, 0.9),
          $login-background 35%,
          $login-background
      );
    }
    @include brandCustom-loginBg();
    &:before {
      content: "";
      width: 100%;
      height: 100%;
      background-image: url($brandImage-LoginBgBefore);
      background-repeat: no-repeat;
      background-position: right bottom;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.4;
      z-index: 0;
      @include brandCustom-loginBgBefore();
    }
  }
  &__content {
    color: $login-text-color;
    @media (max-width: $screen-l-max) {
      padding: 0 $sp-margin-large;
    }
    @media (min-width: $screen-l) {
      display: flex;
    }
  }
  &__brand {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: $sp-margin-larger;
    @media (max-width: $screen-l-max) {
      margin-top: $sp-margin-large;
      flex-direction: row;
      max-width: ($sp * 80) + $sp-margin-larger;
      padding-right: 0;
      margin-bottom: $sp-margin;
    }
  }
  .dwall {
    margin-bottom: $sp-margin;
    @media (max-width: $screen-l-max) {
      margin-bottom: $sp-margin-small;
      width: 80%;
      height: auto;
    }
  }
  .powered-by {
    width: 11rem;
    display: block;
    color: $login-powered-by-color;
    @media (max-width: $screen-l-max) {
      width: 90%;
      height: auto;
    }
  }
  &__form {
    max-width: ($sp * 80) + $sp-margin-larger;
    @media (min-width: $screen-l) {
      padding-left: $sp-margin-larger;
      border-left: 1px solid $login-form-right-border;
    }
    form {
      margin-bottom: $sp-margin;
    }
  }
  &__help {
    a {
      color: $link-dark;
      font-weight: bold;
    }
  }
  &__help-pass {
    font-weight: 700;
    a {
      color: $white;
    }
  }
}
.logo-horizontal {
  width: 800px;
  margin-bottom: $sp-margin;
  @media (max-width: $screen-l-max) {
    display: none;
  }
}
.logo-square-wrapper {
  width: 38%;
  flex-shrink: 0;
  padding-left: $sp-margin;
  border-left: 1px solid $white;
  display: flex;
  align-items: center;
  @media (min-width: $screen-l) {
    display: none;
  }
}
.logo-square {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/AssignLicense.vue